import { InputType } from 'src/app/common/components/reactive-form-builder/interfaces/input.interface';
import {
    Form,
    FormField,
    FormFieldConditions,
    FormSection,
    FormType,
} from 'src/app/common/components/reactive-form-builder/interfaces/form.interface';
import { TareaFertiModel } from 'src/app/models/tareas/tarea-ferti.model';
import { environment } from 'src/environments/environment';

export class CostesFertilizantesFormDefinition {
    public formType!: FormType;

    public formFields!: Form<TareaFertiModel>;

    public fieldNames: FormField<TareaFertiModel>[] = [];

    public fieldLabels: string[] = [];

    constructor(type: FormType = FormType.INFORMATIVE) {
        this.formType = +type;

        this.formFields = {
            name: 'costes-fertilizantes',
            header: 'Detalle del registro',
            type: this.formType,
            sections: this.getFormSections(),
            table: null,
            uploadButton: {
                isEnabled: false,
                label: '',
            },
            signed: false,
        };
    }

    private getFormSections(): FormSection<TareaFertiModel>[] {
        return [
            {
                name: '',
                width: 12,
                isVisible: true,
                fields: this.getMainFields(),
                order: 1,
            },
        ];
    }

    private getMainFields(): FormField<TareaFertiModel>[] {
        const fields: FormField<TareaFertiModel>[] = [
            this.textField('finca', environment.features.fincaName, 1),
            this.textField('sectores_nombres', environment.features.sectoresName, 2),
            this.textField('parcelas_nombres', environment.features.parcelasName, 3),
            this.textField('fecha_fin', 'Fecha', 4),
            this.textField('tratamiento_nombre', 'Tratamientos', 5, environment.appName !== 'ava'),
            this.textField('maquinaria', 'Maquinaria', 6, environment.appName !== 'ava'),
            this.textField('litros', 'Litros', 7, environment.appName !== 'ava'),
            this.textField('eficacia', 'Eficacia', 8, environment.appName !== 'ava'),
            this.switchField('aplicado', 'Aplicado', 9),
        ];

        return this.registerVisibleFields(fields);
    }

    private textField(name: string, label: string, order: number, isVisible = true): FormField<TareaFertiModel> {
        return {
            name,
            vinculatedFields: undefined,
            label,
            input: {
                type: InputType.ONLY_TEXT,
                isEditable: false,
            },
            width: 3,
            conditions: this.conditions({ isVisible }),
            order,
        };
    }

    private switchField(name: string, label: string, order: number): FormField<TareaFertiModel> {
        return {
            name,
            vinculatedFields: undefined,
            label,
            input: {
                type: InputType.SWITCH,
                isEditable: false,
            },
            width: 3,
            conditions: this.conditions(),
            order,
        };
    }

    private registerVisibleFields(fields: FormField<TareaFertiModel>[]): FormField<TareaFertiModel>[] {
        for (const field of fields) {
            if (field.conditions.isVisible) {
                this.fieldNames.push(field);
                this.fieldLabels.push(field.label);
            }
        }

        return fields.sort((a, b) => a.order - b.order);
    }

    private conditions(overrides: Partial<FormFieldConditions> = {}): FormFieldConditions {
        return {
            isRememberedOnDuplicate: false,
            isRequired: false,
            isRetained: false,
            hasUndoEnabled: false,
            isVisible: true,
            ...overrides,
        };
    }
}
